import { z } from "zod";
import { MetaSchema } from "./shared";

export const WalletBaseSchema = z.object({
  id: z.string().uuid(),
  investAmount: z.string(),
  balance: z.string(),
  equityBalance: z.string(),
  gGold: z.union([z.string(), z.number()]),
  dailyProfit: z.string(),
  profitCanWithdraw: z.string(),
  matchingReward: z.string(),
  address: z.string(),
  createdAt: z.string().datetime(),
  investUpdatedAt: z.string().datetime().optional().nullable(),
});

export const TransferSenderSchema = z.object({
  id: z.string().uuid(),
});

export const TransferReceiverSchema = z.object({
  id: z.string().uuid(),
  uuid: z.string(),
  isActivePlan: z.boolean(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  gender: z.string().nullable(),
  role: z.string(),
  rank: z.string().optional().nullable(),
  username: z.string().nullable(),
  email: z.string().nullable(),
  avatar: z.string().optional().nullable(),
  activatedPlanAt: z.string().datetime().optional().nullable(),
  createdAt: z.string().datetime(),
  deletedAt: z.string().datetime().optional().nullable(),
  wallet: WalletBaseSchema,
});

export const TransferDetailsSchema = z.object({
  id: z.string().uuid(),
  amount: z.string(),
  user: TransferSenderSchema,
  transaction_type: z.string(),
  status: z.string(),
  wallet: WalletBaseSchema,
  coin: z.string(),
  transferTo: TransferReceiverSchema,
  created_at: z.string().datetime(),
  completedAt: z.string().datetime().nullable(),
  type: z.string().nullable(),
  tracerKey: z.union([z.string(), z.number()]).nullable(),
  useGGold: z.string().nullable(),
  useProfit: z.string().nullable(),
  hash: z.string().nullable(),
  description: z.string().nullable(),
  value: z.string(),
  fee: z.string(),
});

export const WalletTransferDataSchema = z.object({
  message: z.string(),
  transfer: TransferDetailsSchema,
});

const WalletTransferResponse = z.object({
  data: WalletTransferDataSchema,
  meta: MetaSchema.default,
});

export type WalletTransferResponseType = z.infer<typeof WalletTransferResponse>;

export default WalletTransferResponse;
